import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ContractSignature from './contract-signature';
import ContractSignatureDetail from './contract-signature-detail';
import ContractSignatureUpdate from './contract-signature-update';
import ContractSignatureDeleteDialog from './contract-signature-delete-dialog';

const ContractSignatureRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ContractSignature />} />
    <Route path="new" element={<ContractSignatureUpdate />} />
    <Route path=":id">
      <Route index element={<ContractSignatureDetail />} />
      <Route path="edit" element={<ContractSignatureUpdate />} />
      <Route path="delete" element={<ContractSignatureDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ContractSignatureRoutes;
